import React, { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { getCookie } from "../../../../util/cookie/cookies";

export const Lang = () => {
    const clRef = useRef<any>(null)
    const [cookie, setCookie] = useCookies(['HYUNDAILANG'])
    const [langActive, setLangActive] = useState<boolean>(false)
    const lang = getCookie('HYUNDAILANG')
    const { t, i18n } = useTranslation();
    const handleLangChangeKr =()=>{setCookie('HYUNDAILANG', 'kr' , {path : '/'}); i18n.changeLanguage('kr')}
    const handleLangChangeEn =()=>{setCookie('HYUNDAILANG', 'en', {path : '/'}); i18n.changeLanguage('en')}
    useEffect(()=>{
        const handleOutSide = (e:any) =>{
            if(clRef.current&&!clRef.current.contains(e.target)){
                setLangActive(false);
            }
        }
        document.addEventListener('mousedown', handleOutSide);
        return()=> {
            document.removeEventListener('mousedown', handleOutSide)
        }
    })
    return(
        <>
        
        <div className="rightBox" ref={clRef}>
            <div className="langBox">
                <button onClick={()=>setLangActive(prev => !prev)}></button>
                {/* 버튼 클릭 시 아래 div에 active클래스 추가, 언어 선택 시 div 내에 있는 span에 active클래스 추가 */}
                <div className={langActive ? 'active' :''}>
                    <span className={lang==='en'?'active':''} onClick={handleLangChangeEn}>EN</span>
                    <span className={lang==='kr'?'active':''} onClick={handleLangChangeKr}>KR</span>
                </div>
            </div>
        </div>
        

        </>
    )
}